<template>
    <Transition name="fade">
        <aside class="modal" v-if="opened">
            <Form v-if="$route.query.action && $route.query.model && ($auth.user.is_admin || $route.query.admin === 'false')" ref="form" @click.stop />
            <ImageFullWidth v-if="$route.query.i" ref="vimeo" @click.stop />
        </aside>
    </Transition>
</template>

<script>
import { Form, ImageFullWidth } from '@/components/modal/'
import { bodyHelpers } from '@/helpers'

export default {
    name: 'Modal',
    components: {
        Form,
        ImageFullWidth
    },
    computed: {
        opened() {
            return this.$route.query.i || (this.$route.query.action && this.$route.query.model)
        }
    },
    watch: {
        'opened'() {
            this.opened ? bodyHelpers.lockBody() : bodyHelpers.unlockBody()
        }
    },
    methods: {
        close() {
            this.$router.push({ ...this.$route, query: {...( this.$route.query.date ? { date: this.$route.query.date } : {} ), ...( this.$route.query.filter ? { filter: this.$route.query.filter } : {} )} })
        }
    }
}
</script>